import React from 'react';
import { motion } from 'framer-motion';
import { researchPriorities } from '../../data/research';
import { fadeUp } from '../../utils/motion';
export function ResearchPriorities() {
  return <section id="research-priorities" className="scroll-mt-20 bg-white py-20 lg:py-28" data-id="element-1908" data-mp="2k7uji07q7icd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1909" data-mp="2p65tcay0tsul">
        <motion.h2 {...fadeUp} className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-14" data-id="element-1910" data-mp="2p6nkwu9qniw6">
          Research priorities
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 border-t border-line" data-id="element-1911" data-mp="3gwsbxbs0746d">
          {researchPriorities.map(priority => <motion.article key={priority.title} {...fadeUp} className="border-b border-line py-10" data-id="element-1912" data-mp="37wdr0diybr3e">
              <h3 className="font-heading font-bold text-2xl text-ink-dark mb-4" data-id="element-1913" data-mp="1ri413ez29uag">{priority.title}</h3>
              <div className="space-y-4" data-id="element-1914" data-mp="1wi9ogiyasumq">
                {priority.paragraphs.map(paragraph => <p key={paragraph} className="text-lg text-ink-muted leading-relaxed" data-id="element-1915" data-mp="37sgu1cq6862r">
                    {paragraph}
                  </p>)}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}